module.exports = __webpack_public_path__ + "img/symbol_3.0bbf6367.png";